import { render, staticRenderFns } from "./assetManagement.vue?vue&type=template&id=ccc9c698&scoped=true&"
import script from "./assetManagement.vue?vue&type=script&lang=js&"
export * from "./assetManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc9c698",
  null
  
)

component.options.__file = "assetManagement.vue"
export default component.exports